// import {
// 	fetchComuni,
// 	fetchNazioni,
// 	fetchRegioni,
// 	resetNazioni,
// } from "components/anagrafiche/comuni/comuniSlice";
// import { fetchProduttori } from "./anagrafiche/produttori/produttoriSlice";

import {
	// utenteTokenRefresh,
	UtenteLogged,
} from "components/authentication/authenticationSlice";
import {fetchReparti} from "./anagrafiche/reparti/repartiSlice";
import {fetchOperatori} from "./main/personale/operatoriSlice";

// import { conteggioTaskAttivi } from "components/tasks/tasksSlice";

export const fetchAnagrafiche = (
	dispatch: any,
	utente: UtenteLogged,
	ritardoScaglionamento: number, // Ritarda ogni dispatch di 1000 == secondo
) => {
	const actions:any[] = [
		// console.log('fetch anagrafiche')
		() => dispatch(fetchReparti()),
		() => dispatch(fetchOperatori()),
		// () => dispatch(fetchComuni({ ultimoAggiornamento: comuniUltimoAggiornamento })),
		// () => dispatch(fetchRegioni({})),
		// () => dispatch(fetchNazioni({})),
	];

	//

	if (utente.isLogged) {
		actions.forEach((action, index) => {
			setTimeout(action, index * ritardoScaglionamento); // Ritarda ogni dispatch di 1 secondo
		});
	}
};

export const resetAnagrafiche = (dispatch: any) => {
	// dispatch(resetNazioni());
};
